import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Row,
  Col,
  Spin,
  Card,
  Skeleton,
  Divider,
} from "antd";
import { ModalConfirm } from "@empreinte/components.modal-confirm";
import { Pagination } from "@empreinte/components.pagination";
import {
  TextField,
  Menu,
  MenuItem
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { ReactComponent as SearchIcon } from "../assets/Search.svg";
import "./skinPlayer.scss";
import PlayerCard from "./PlayerCard";
import { useAppSelector } from "../../../Redux/hooks";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import SkinHooks from "../utils/Hooks";
import { useDispatch } from "react-redux";
import {
  setAddMediaActions,
  setResetSkinPage,
  setSkinShowCondition,
  setPaginationSkin
} from "../store/skinActions";
import { SkinPlayer } from "./SkinPlayer";
const DefaultPage = 5;
export const RegisterSkins = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    skinsDisplay,
    getListSkin,
    deleteSkin,
    editSkin,
    addSkin,
    getSkinLink,
    resetSkin,
    applySkin
  } = SkinHooks();

  // Redux state selectors
  const values = useAppSelector(
    (state) => state.skinReducer.AddMediaConstraintsData
  );
  const isLoading = useAppSelector((state) => state.skinReducer.loadingSkins);
  const registeredSkins = useAppSelector((state) => state.skinReducer.skins);
  const total = useAppSelector(
    (state) => state.skinReducer.paginationProps.skinTotal
  );
  const currentPage = useAppSelector(
    (state) => state.skinReducer.paginationProps.current
  );
  const loaderBoxes = useAppSelector((state) => state.skinReducer.loaderBox);
  const showSkinCondition = useAppSelector(
    (state) => state.skinReducer.AddSkinContraints
  );
  const resetSkinPage = useAppSelector(
    (state) => state.skinReducer.resetSkinPage
  );
  const nbVideosChannel = useAppSelector(
    (state) => state.skinReducer.nbVideosChannel
  );
  const latestId = useAppSelector(
    (state) => state.skinReducer.latestId
  )
  const errorVideo = useAppSelector(
    (state) => state.skinReducer.errorVideo
  )

  // State variables
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedSkin, setSelectedSkin] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [page, setPage] = useState(DefaultPage);
  const [current, setCurrent] = useState(currentPage);
  const [searchWord, setSearchWord] = useState("");
  const [, setOpenModal] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [themeS] = useState("");
  const [nbVideoT, setNbVideoT] = useState(null);
  const [channelS] = useState("");
  const [nbVideoC, setNbVideoC] = useState(null);
  const [defaultS, isDefaultS] = useState(false);
  const [loadingBox, setLoadingBox] = useState(false);
  const open = Boolean(anchorEl);

  // useEffect
  useEffect(() => {
    resetSkin();
    dispatch(setResetSkinPage(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(()=>{
    if(!latestId)return;
    getSkinLink(latestId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[latestId])
  //ça sera commenté en cas de besoin
  // useEffect(()=>{
  //   if(openModal === true){
  //     GetThemes();
  //     GetChannels();
  //   }
  // },[openModal,open])
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingBox(false);
    }, 2000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (showSkinCondition?.isSearch === "" && searchWord) {
      setSearchWord("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSkinCondition?.isSearch, searchWord]);
  useEffect(() => {
    if (nbVideosChannel !== null) {
      setNbVideoC(nbVideosChannel);
      setNbVideoT(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelS, nbVideosChannel]);
  useEffect(() => {
    if (showSkinCondition?.isSearch) {
      skinsDisplay(current, page, showSkinCondition?.isSearch);
    } else {
      skinsDisplay(current, page, "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, page, showSkinCondition?.isSearch,showSkinCondition]);
  useEffect(() => {
    let selectedName =
      registeredSkins &&
      registeredSkins
        .filter((item) => item.id === selectedId)
        .map((item) => item.name)
        .join(", ");
    setSelectedSkin(selectedName);
    if (selectedId) {
      getListSkin(selectedId);
    } else {
      // getListSkin(values.skin_id); // remove get default selected skin 
      setSelectedId(!selectedId ? 1 : selectedId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId, values.skin_id]);

  // Functions
  const handlePageChange = (page) => {
    setCurrent(page);
    dispatch(
      setPaginationSkin({
        PaginationSkinNameChange: "current",
        PaginationSkinValueChange: page,
      })
    );
  };
  const handlePageSizeChange = (size) => {
    setPage(size);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    await deleteSkin(selectedId);
    handleClose();
    setCurrent(1);
    if (selectedId === values?.skin_id) {
      setSelectedId(1);
    }
  };

  const handleClickBox = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const onSearch = (e) => {
    dispatch(
      setSkinShowCondition({
        showSkinConditionsName: "isSearch",
        showSkinConditionsValue: e?.target?.value,
      })
    );
    setSearchWord(e?.target?.value);
    setCurrent(1);
    dispatch(
      setPaginationSkin({
        PaginationSkinNameChange: "current",
        PaginationSkinValueChange: 1,
      })
    );
  };

  return (
    <>
      {loadingBox ? (
        <Spin size="large" fullscreen className="spinner" />
      ) : (
        <Card>
          <Row>
            <Col
              xs={{ span: 24, offset: 0, order: 2 }}
              md={{ span: 24, offset: 0, order: 2 }}
              lg={{ span: 10, offset: 0, order: 1 }}
              xl={{ span: 11, offset: 0, order: 1 }}
              xxl={{ span: 12, offset: 0, order: 1 }}
            >
              {(showSkinCondition.isAdd || showSkinCondition.isEdit) &&
              !resetSkinPage ? (
                <SkinPlayer />
              ) : (
                <Card>
                  {isLoading ? (
                    <Spin size="large" fullscreen className="spinner" />
                  ) : (
                    <>
                      <TextField
                        id="outlined-basic"
                        size="large"
                        placeholder={t("Skin-Player.skin-search")}
                        onChange={onSearch}
                        fullWidth
                        className="search-skin"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            boxShadow: "none !important", // Remove boxShadow
                          },
                        }}
                      />

                      {/* <Card> */}
                      <Row className="card-antd-body ">
                        {loaderBoxes ? (
                          <div className="Cards">
                            {[...Array(6)].map((_, index) => (
                              <div className="box" key={index}>
                                <Skeleton active />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="Cards">
                            <div
                              className="box addSkin"
                              onClick={async () => {
                                await addSkin();
                                dispatch(setResetSkinPage(false));
                              }}
                            >
                              <AddRoundedIcon
                                style={{
                                  fontSize: "4rem",
                                  color: "#F5F5F5",
                                  border: "5px solid  #F5F5F5",
                                  borderRadius: "20px",
                                  cursor: "pointer",
                                  transition:"0.3s all ease-in-out"
                                }}
                                className="skin-icon skin-icon-add"
                              />
                              <span className="skin-card-title skin-card-title-add ">
                                {t("Skin-Player.add-skin")}
                              </span>
                            </div>
                            {registeredSkins &&
                              registeredSkins?.map((skin) => {
                                return (
                                  <div
                                    className={`box ${
                                      selectedId === skin?.id ? "active" : ""
                                    }`}
                                    onClick={(e) => {
                                      setSelectedSkin(skin.name);
                                      handleClickBox(skin.id);
                                      setSelectedId(skin.id);
                                      isDefaultS(!!(skin?.id === 1));
                                      dispatch(
                                        setAddMediaActions({
                                          addMediaConstraintsDataNameChange:
                                            "skin_id",
                                          addMediaConstraintsDataValueChange:
                                            skin?.id ? skin?.id : 1,
                                        })
                                      );
                                    }}
                                    key={skin.id}
                                  >
                                    <MoreHorizOutlinedIcon
                                      className="more-box"
                                      onClick={(e) => handleClick(e, skin.id)}
                                      key={skin.id}
                                    />

                                    <ColorLensOutlinedIcon
                                      style={{
                                        fontSize: "5rem",
                                        color: "#6B6B89",
                                      }}
                                      className="skin-icon"
                                    />
                                    <span className="skin-card-title">
                                      {skin.name}
                                    </span>
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      </Row>

                      <Row></Row>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                        PaperProps={{
                          elevation: 0,
                          sx: {
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            mt: 1.5,
                            "& .MuiAvatar-root": {
                              width: 32,
                              height: 32,
                              ml: -0.5,
                              mr: 1,
                            },
                          },
                        }}
                        transformOrigin={{
                          horizontal: "right",
                          vertical: "top",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                      >
                        <MenuItem
                          onClick={(e) => {
                            editSkin(selectedId);
                            dispatch(setResetSkinPage(false));
                            handleClose();
                          }}
                          className="menu-toggle"
                        >
                          <CreateRoundedIcon /> {t("Skin-Player.edit")}
                        </MenuItem>
                        {!defaultS && (
                          <MenuItem
                            onClick={handleDelete}
                            className="menu-toggle"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="22"
                              viewBox="0 0 20 22"
                              fill="none"
                            >
                              <path
                                d="M7.72727 3.66667H12.2727C12.2727 3.05888 12.0333 2.47598 11.6071 2.04621C11.1808 1.61644 10.6028 1.375 10 1.375C9.39724 1.375 8.81916 1.61644 8.39294 2.04621C7.96672 2.47598 7.72727 3.05888 7.72727 3.66667ZM6.36364 3.66667C6.36364 2.69421 6.74675 1.76158 7.4287 1.07394C8.11065 0.386308 9.03558 0 10 0C10.9644 0 11.8893 0.386308 12.5713 1.07394C13.2532 1.76158 13.6364 2.69421 13.6364 3.66667H19.3182C19.499 3.66667 19.6724 3.7391 19.8003 3.86803C19.9282 3.99696 20 4.17183 20 4.35417C20 4.5365 19.9282 4.71137 19.8003 4.8403C19.6724 4.96923 19.499 5.04167 19.3182 5.04167H18.1273L17.0209 18.4278C16.9404 19.4015 16.4999 20.3093 15.7868 20.971C15.0737 21.6326 14.14 21.9999 13.1709 22H6.82909C5.85999 21.9999 4.92631 21.6326 4.21319 20.971C3.50006 20.3093 3.05958 19.4015 2.97909 18.4278L1.87273 5.04167H0.681818C0.500989 5.04167 0.327566 4.96923 0.1997 4.8403C0.0718341 4.71137 0 4.5365 0 4.35417C0 4.17183 0.0718341 3.99696 0.1997 3.86803C0.327566 3.7391 0.500989 3.66667 0.681818 3.66667H6.36364ZM4.33818 18.3132C4.39017 18.9433 4.67511 19.5307 5.1365 19.9589C5.59788 20.3871 6.20201 20.6249 6.82909 20.625H13.1709C13.798 20.6249 14.4021 20.3871 14.8635 19.9589C15.3249 19.5307 15.6098 18.9433 15.6618 18.3132L16.76 5.04167H3.24091L4.33818 18.3132ZM7.95455 8.25C8.13538 8.25 8.3088 8.32243 8.43666 8.45136C8.56453 8.5803 8.63636 8.75516 8.63636 8.9375V16.7292C8.63636 16.9115 8.56453 17.0864 8.43666 17.2153C8.3088 17.3442 8.13538 17.4167 7.95455 17.4167C7.77372 17.4167 7.60029 17.3442 7.47243 17.2153C7.34456 17.0864 7.27273 16.9115 7.27273 16.7292V8.9375C7.27273 8.75516 7.34456 8.5803 7.47243 8.45136C7.60029 8.32243 7.77372 8.25 7.95455 8.25ZM12.7273 8.9375C12.7273 8.75516 12.6554 8.5803 12.5276 8.45136C12.3997 8.32243 12.2263 8.25 12.0455 8.25C11.8646 8.25 11.6912 8.32243 11.5633 8.45136C11.4355 8.5803 11.3636 8.75516 11.3636 8.9375V16.7292C11.3636 16.9115 11.4355 17.0864 11.5633 17.2153C11.6912 17.3442 11.8646 17.4167 12.0455 17.4167C12.2263 17.4167 12.3997 17.3442 12.5276 17.2153C12.6554 17.0864 12.7273 16.9115 12.7273 16.7292V8.9375Z"
                                fill="#62626B"
                              />
                            </svg>{" "}
                            {t("Skin-Player.delete")}
                          </MenuItem>
                        )}
                        {/* <MenuItem
                          onClick={() => {
                            setOpenModal(true);
                            handleClose();
                          }}
                          className="menu-toggle"
                        >
                          <FormatPaintRoundedIcon />
                          {t("Skin-Player.choose")}
                        </MenuItem> */}
                      </Menu>

                              {/* cette partie sera commenté en cas de besoin  */}
                      {/* Modal select theme or channel */}
                    
                      {/* <ModalInputs
                        headerStyle={{ color: "white" }}
                        open={openModal}
                        onClose={() => handleCancelInput()}
                        title={`${t(
                          "Skin-Player.applySkin"
                        )} : ${selectedSkin} `}
                        onCancel={() => handleCancelInput()}
                        onConfirm={() => {
                          setOpenModal(false);
                          setOpenConfirm(true);
                        }}
                        CancelBtnName={t("cancel")}
                        ConfirmBtnName={t("enregistrer")}
                        style={{
                          background: "rgba(0, 0, 0, 0.12)",
                          backdropFilter: "blur(1px)",
                          zIndex: "6",
                          borderRadius: "none",
                        }}
                        btnstyle={{
                          marginRight: "18px",
                        }}
                        disabled={!themeS && !channelS}
                      >
                        <div
                          style={{
                            margin: "20px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                          }}
                        >
                          <div>
                            <span className="titleCT">
                              {t("Skin-Player.themes")}
                            </span>
                            <Select
                              value={themeS ? themeS : themesSKin[0]?.Id}
                              allowClear
                              disabled={
                                channelS || channelsSkin[0]?.id ? true : false
                              }
                              onChange={(e) => {
                                setThemeS(e);
                                const selectedThemeObject = themesList.find(
                                  (theme) => theme.Id === e
                                );

                                if (selectedThemeObject) {
                                  setNbVideoT(
                                    selectedThemeObject.WebtvVideo.length
                                  );
                                }
                              }}
                              onClear={() => {
                                setThemeS("");
                                // setNbVideoT(0);
                                dispatch(setThemeSelectedSkin([]));
                              }}
                              style={{ width: "100%" }}
                              size="large"
                            >
                              {themesList.map((theme) => (
                                <MenuItem key={theme.Id} value={theme.Id}>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "15px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <ListItemText>{theme.Title}</ListItemText>
                                    <ListItemIcon>
                                      ({theme.WebtvVideo.length} videos )
                                    </ListItemIcon>
                                  </div>
                                </MenuItem>
                              ))}
                            </Select>
                            {nbVideoT && themeS ? (
                              <span className="checked ch">
                                <CheckCircleOutlineIcon fontSize="smaller" />{" "}
                                {t("Skin-Player.thisSkin")} {nbVideoT}{" "}
                                {t("Skin-Player.theme")}{" "}
                              </span>
                            ) : null}
                            {channelS || channelsSkin[0]?.id ? (
                              <span className="checked err">
                                <InfoOutlinedIcon fontSize="smaller" />{" "}
                                {t("Skin-Player.disabledTheme")}{" "}
                              </span>
                            ) : null}
                          </div>
                          <div>
                            <span className="titleCT">
                              {t("Skin-Player.channels")}
                            </span>
                            <Select
                              value={channelS ? channelS : channelsSkin[0]?.id}
                              // style={{ height: '50px' ,borderRadius:"6px"}}
                              size="large"
                              allowClear
                              style={{ width: "100%" }}
                              onClear={() => {
                                setChannelS("");
                                // setNbVideoC(0)
                                dispatch(setChannelSelectedSkin([]));
                              }}
                              onChange={(e) => {
                                setChannelS(e);
                                getChannelVideos(e);

                                // const selectedChannel = themesList
                                // .flatMap(theme => theme.WebtvChannel) // Combine all channels from all themes into one array
                                // .find(channel => channel.Id === e); // Find the selected channel
                                // if (selectedChannel?.Id) {
                                // 	const videosForSelectedChannel = themesList
                                // 		.flatMap(theme => theme?.WebtvVideo)
                                // 		.filter(video => {

                                // 			return video.Id ;
                                // 		});
                                // 	setNbVideoC(videosForSelectedChannel?.length)
                                // }else{
                                // 	setNbVideoC(0)
                                // }
                              }}
                              disabled={
                                themeS || themesSKin[0]?.Id ? true : false
                              }
                            >
                              {channelsList.map((channel) => (
                                <MenuItem key={channel.Id} value={channel.Id}>
                                  {channel.Title}
                                </MenuItem>
                              ))}
                            </Select>
                            {nbVideoC && channelS ? (
                              <span className="checked ch">
                                <CheckCircleOutlineIcon fontSize="smaller" />{" "}
                                {t("Skin-Player.thisSkin")} {nbVideoC}{" "}
                                {t("Skin-Player.channel")}{" "}
                              </span>
                            ) : null}
                            {themeS || themesSKin[0]?.Id ? (
                              <span className="checked err">
                                <InfoOutlinedIcon fontSize="smaller" />{" "}
                                {t("Skin-Player.disabledChannel")}{" "}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      </ModalInputs> */}


                      {/* Modal confirm after select */}
                      <ModalConfirm
                        open={openConfirm}
                        onClose={() => setOpenConfirm(false)}
                        title={t("Skin-Player.apply-skin-title")}
                        content={`${t("Skin-Player.apply-skin-content")} ${
                          themeS ? nbVideoT : nbVideoC
                        } ${
                          themeS
                            ? nbVideoT === 1
                              ? t("Skin-Player.one-video")
                              : t("Skin-Player.many-videos")
                            : nbVideoC === 1
                            ? t("Skin-Player.one-video")
                            : t("Skin-Player.many-videos")
                        }?`}
                        fullWidth={true}
                        CancelBtnName={t("cancel")}
                        ConfirmBtnName={t("confirm")}
                        onCancel={() => {
                          setOpenConfirm(false);
                          setOpenModal(true);
                        }}
                        onConfirm={() => {
                          applySkin(themeS, channelS, selectedId);
                          setOpenConfirm(false);
                        }}
                      ></ModalConfirm>

                      {/* </Card> */}
                      <Divider />
                      <Pagination
                        ShowName=" page"
                        EntriesName={t("Skin-Player.Elements")}
                        OfPageName={t("Skin-Player.of")}
                        pageSize={page}
                        currentPage={current}
                        totalEntities={total}
                        setCurrentPage={handlePageChange}
                        setPageSize={handlePageSizeChange}
                      ></Pagination>
                    </>
                  )}
                </Card>
              )}
            </Col>
            <Col
              xs={{ span: 24, offset: 0, order: 1 }}
              md={{ span: 24, offset: 0, order: 1 }}
              lg={{ span: 14, offset: 0, order: 2 }}
              xl={{ span: 13, offset: 0, order: 1 }}
              xxl={{ span: 12, offset: 0, order: 1 }}
            >
              {/* <Card> */}
             <div className="generated-skin">
             {!errorVideo &&
             <>
                {showSkinCondition.isAdd || showSkinCondition.isEdit ? null : (
                  <span className="Skin-title commonClass">
                    {t("Skin-Player.player-preview")}
                    {selectedSkin ? `: ${selectedSkin}` : ""}{" "}
                  </span>
                )}
                <PlayerCard /></>
                // <BrokenVideo className="brokenVideo"/>
                }
              </div> 
              {/* </Card> */}
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};
